import { Router } from '@reach/router';
import React from 'react';
import { RouteComponentProps } from '../helpers/RouteComponentProps';
import { routes } from '../helpers/routes';
import { UserProvider } from '../users/UserProvider';
import { AuthenticationFlow } from './AuthenticationFlow';
import { AuthenticationProvider } from './AuthenticationProvider';
import { LayoutRoutes } from './LayoutRoutes';
import { PdfRoute } from './PdfRoute';
import { projectRoutes } from '../features/projects/projectRoutes';

type AuthenticatedRoutesComponent = {
  (props: RouteComponentProps): JSX.Element;
};

export const AuthenticatedRoutes: AuthenticatedRoutesComponent = () => (
  <AuthenticationProvider>
    {authentication => (
      <AuthenticationFlow {...authentication}>
        <UserProvider>
          <Router primary={false}>
            <PdfRoute path={`${routes.projectSection}${projectRoutes.manifoldDiagramPdf}`} />
            <LayoutRoutes logOut={authentication.logOut} path={'/*'} />
          </Router>
        </UserProvider>
      </AuthenticationFlow>
    )}
  </AuthenticationProvider>
);
